import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const Select = ({
  onChangeFunction,
  onBlurFunction,
  onFocusFunction,
  name,
  type,
  placeholder,
  valid,
  error,
  normal,
  errorText,
  required,
  inputValue,
  extraClasses,
  accessable,
  disable,
  bottomLined,
  dataqa,
  options,
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const componentClass = classNames(`input-container ${extraClasses}`, {
    error,
    normal,
    'underlined-input': bottomLined,
    valid,
  });
  const showError = error && errorText;

  return (
    <>
      <div className={componentClass}>
        <div className="form-group">
          <select
            {...props}
            className={`form-control field__${name}`}
            data-qa={dataqa}
            name={name}
            onBlur={(event) => onBlurFunction(event)}
            onChange={(event) => onChangeFunction(event)}
            onFocus={(event) => onFocusFunction(event)}
            required={required}
            type={type}
            value={inputValue}
            {...(disable && { disabled: 'disabled' })}
            {...(accessable && { 'aria-label': `${placeholder}` })}
          >
            <option value="">{placeholder}</option>
            {options.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <div
            className={classNames('chevron', { 'chevron--disabled': disable })}
          >
            <FontAwesomeIcon icon={faChevronDown} />
          </div>
        </div>
        {Boolean(showError) && (
          <div className="bg-danger">
            <span>{errorText}</span>
          </div>
        )}
      </div>
      <style jsx>{`
        .form-control {
          appearance: none;
          padding-right: 42px;
        }
        .chevron {
          position: absolute;
          right: 16px;
          top: 11px;
        }
        .chevron--disabled {
          opacity: 0.2;
        }
        .form-control:focus {
          border-color: ${theme.colors.inputfocuscolor};
        }
        .underlined-input .form-control:focus {
          border-color: ${theme.colors.inputlogincolor};
        }
        .underlined-input.valid .form-control {
          border-bottom-color: ${theme.colors.inputlogincolor};
        }
        .lowercase_placeholder .form-control::placeholder {
          text-transform: lowercase;
        }
        .error .form-control,
        .error .form-control:focus {
          border-color: ${theme.colors.inputinvalidcolor};
        }
        .bg-danger {
          background: ${theme.colors.inputinvalidcolor};
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          .mobile-highlight-border .form-control,
          .mobile-highlight-border.underlined-input .form-control:focus,
          .mobile-highlight-border.underlined-input.valid .form-control {
            border-color: ${theme.colors.primary};
          }
        }
        .form-control:disabled {
          border: 1px solid transparent !important;
        }
      `}</style>
    </>
  );
};

Select.propTypes = {
  accessable: PropTypes.bool,
  bottomLined: PropTypes.bool,
  dataqa: PropTypes.string,
  disable: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  extraClasses: PropTypes.string,
  inputValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  normal: PropTypes.bool,
  onBlurFunction: PropTypes.func,
  onChangeFunction: PropTypes.func.isRequired,
  onFocusFunction: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, value: PropTypes.string }),
  ),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
  valid: PropTypes.bool,
  value: PropTypes.string,
};

Select.defaultProps = {
  accessable: true,
  bottomLined: false,
  dataqa: null,
  disable: false,
  error: false,
  errorText: '',
  extraClasses: '',
  inputValue: '',
  name: '',
  normal: false,
  onBlurFunction: () => {},
  onFocusFunction: () => {},
  options: [],
  placeholder: '',
  required: true,
  type: '',
  valid: false,
  value: '',
};

export default Select;
